var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.521,
    height: 49.733,
    viewBox: "0 0 49.521 49.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconfinder_stop_1_677407",
    d: "M2,34.024v-14.3a5.876,5.876,0,0,1,1.76-4.3L15.338,3.786A5.823,5.823,0,0,1,19.612,2h14.24A5.834,5.834,0,0,1,38.13,3.786l11.6,11.636a5.91,5.91,0,0,1,1.79,4.3v14.3a5.9,5.9,0,0,1-1.79,4.3L38.139,49.955a5.849,5.849,0,0,1-4.287,1.779H19.612a5.832,5.832,0,0,1-4.279-1.779L3.76,38.322A5.873,5.873,0,0,1,2,34.024Zm12.38-11.3v8.289H39.14V22.722Z",
    transform: "translate(-2 -2)",
    fill: "#ff594f",
    fillRule: "evenodd",
    opacity: 0.587
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.a6b8a9f0320342e3bb67a561840017b8.svg";
export { ForwardRef as ReactComponent };